import {createAction} from '@reduxjs/toolkit'

export const markRecording = createAction('MARK_RECORDING')
export const markNotRecording = createAction('MARK_NOT_RECORDING')
